import PayrollList from './PayrollList';

export default PayrollList;